import { Component, EventEmitter, Input, Output } from '@angular/core';
import { MatStepper } from '@angular/material/stepper';
import { Router } from '@angular/router';
import {
	SelectedUserEvent,
	UserType,
} from 'src/app/components/user-search-bar/user-search-bar.component';
import { NavigationHistoryService } from 'src/app/services/navigation-history.service';
import { NotAuthorizedNoticeComponent } from '../../../components/not-authorized-notice/not-authorized-notice.component';
import { UserSearchBarComponent } from '../../../components/user-search-bar/user-search-bar.component';
import { HasSystemCapabilityDirective } from '../../../directives/system-capabilities/has-system-capability.directive';

@Component({
	selector: 'app-add-user-about',
	templateUrl: './add-user-about.component.html',
	styleUrls: [
		'./add-user-about.component.css',
		'../../common/main.scss',
		'../../common/stepper.scss',
	],
	imports: [
		NotAuthorizedNoticeComponent,
		UserSearchBarComponent,
		HasSystemCapabilityDirective,
	],
})
export class AddUserAboutComponent {
	@Input() stepper!: MatStepper;
	@Output() selectedUserEvents = new EventEmitter<SelectedUserEvent>();
	@Output() checkSelectedUserEvents = new EventEmitter();
	continueDisabled = true;

	constructor(
		private readonly router: Router,
		private readonly navHistory: NavigationHistoryService
	) {}

	onSelectedEvent(event: SelectedUserEvent): void {
		const user = event.user;

		this.continueDisabled =
			event.userType === UserType.newUser &&
			(!event.emailValid ||
				user.firstName.length === 0 ||
				user.lastName.length === 0);

		this.selectedUserEvents.emit(event);
	}

	onCancelClicked(): void {
		this.navHistory.navigateBack();
	}
}
